import React, { useState } from 'react';

const CookiePopup = ({ dispatch }) => {
  const [consents, setConsents] = useState({
    analytics: true,
    marketing: true,
  });

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setConsents((prev) => ({
      ...prev,
      [id]: checked,
    }));
  };

  const handleAccept = () => {
    dispatch({
      type: 'acceptCurrent',
      payload: {
        analytics: consents.analytics,
        marketing: consents.marketing,
      },
    });
  };

  return (
    <div id="cookieConsent" style={{ paddingRight: 6 }}>
      <div className='row'>
        <div className='container'>
          <div id="closeCookieConsent" onClick={() => dispatch({ type: 'declineAll' })}>x</div>

          Ez a weboldal különböző típusú sütiket használ, az 'Elfogadom' gombra kattintással hozzájárulsz mindezekhez. 
          <a href={`${process.env.PUBLIC_URL}/cookie-policy/`}>Részletes süti tájékoztató</a> 
          Az így gyűjtött adatokat elemző, hirdető és média partnereinkkel osztjuk meg. 
          Partnereink ezeket kombinálhatják más adatokkal is.

          <p style={{ marginBottom: 0 }}>Sütik:</p>

          <div className="form-check" style={{ paddingLeft: 0 }}>
            <input hidden className="form-check-input" type="checkbox" id="baseCookie" checked disabled />
            <label className="form-check-label" htmlFor="baseCookie">
              Alapműködést biztosító sütik - a weboldal helyes működését biztosítják.
            </label>
          </div>

          <div className="form-check" style={{ paddingLeft: 0 }}>
            <input
              hidden
              className="form-check-input"
              type="checkbox"
              id="analytics"
              checked={consents.analytics}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label" htmlFor="analytics">
              Analitikai sütik a weboldal használatáról gyűjtenek anonim statisztikai adatokat.
            </label>
          </div>

          <div className="form-check" style={{ paddingLeft: 0 }}>
            <input
              hidden
              className="form-check-input"
              type="checkbox"
              id="marketing"
              checked={consents.marketing}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label" htmlFor="marketing">
              Marketing sütik hirdetések személyre szabásához nyújtanak segítséget.
            </label>
          </div>

          <div>
            <a className="cookieConsentOK" onClick={handleAccept}>Elfogadom</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;
